module.exports = __webpack_public_path__ + "static/media/img6.62f7859a.png";